import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function PlayerDialog({ open, player, onClose, onSave, busy }) {
  const [name, setName] = useState("");
  useEffect(() => {
    if (open) setName(player?.name || "");
  }, [open, player]);
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent aria-describedby={undefined} className="border-slate-200 bg-white text-slate-900" data-testid="player-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl uppercase tracking-wide">{player ? "Edit player" : "Add player"}</DialogTitle>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSave(name);
          }}
          className="space-y-4"
        >
          <input
            data-testid="player-name-input"
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Player name"
            className="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-slate-900 outline-none focus:border-orange-400"
          />
          <button
            data-testid="player-save-button"
            type="submit"
            disabled={busy || !name.trim()}
            className="w-full rounded-lg bg-orange-500 py-2.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-orange-400 disabled:opacity-40"
          >
            {busy ? "Saving…" : "Save"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
